import React from 'react';

const ClaimDetailPaySVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.60889 6.33952C3.80503 4.99258 4.44345 4.48423 5.77798 4.48423H17.8041C18.0021 4.49283 18.1889 4.5748 18.3258 4.71305C18.4626 4.85131 18.5389 5.03518 18.5387 5.22635V6.33952H3.60889ZM20.077 6.37291V5.22635C20.0771 4.64162 19.8388 4.08035 19.4135 3.66377C18.9882 3.2472 18.4101 3.00877 17.8041 3H5.77798C2.43204 3 2.05129 5.6308 2.0013 6.99629C1.99957 7.00984 1.99957 7.02355 2.0013 7.03711V7.08163V18.9555C2.0013 19.5459 2.24441 20.1122 2.67716 20.5297C3.10991 20.9473 3.69684 21.1818 4.30884 21.1818H19.6925C20.3045 21.1818 20.8914 20.9473 21.3241 20.5297C21.7569 20.1122 22 19.5459 22 18.9555V8.56586C21.9994 8.04012 21.8061 7.53153 21.4541 7.13016C21.1022 6.72879 20.6143 6.46054 20.077 6.37291ZM17.5772 15.616C17.2349 15.616 16.9003 15.518 16.6157 15.3345C16.3311 15.1511 16.1093 14.8903 15.9783 14.5852C15.8473 14.2801 15.813 13.9443 15.8798 13.6204C15.9466 13.2965 16.1114 12.999 16.3535 12.7655C16.5955 12.532 16.9039 12.373 17.2396 12.3085C17.5753 12.2441 17.9233 12.2772 18.2395 12.4035C18.5557 12.5299 18.826 12.7439 19.0162 13.0185C19.2064 13.2931 19.3079 13.6159 19.3079 13.9462C19.3084 14.1656 19.264 14.383 19.1772 14.5858C19.0904 14.7886 18.9629 14.9728 18.8021 15.128C18.6413 15.2831 18.4503 15.4061 18.2401 15.4898C18.0299 15.5736 17.8046 15.6164 17.5772 15.616Z"
      className="claimdetails-button-SVG"
    />
  </svg>
);

const ClaimDetailDownloadSVG = () => (
  <svg
    width="9"
    height="11"
    viewBox="0 0 9 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.26995 4.19738H8.55566L4.55566 8.31503L0.555664 4.19738H2.84138V0.667969H6.26995V4.19738ZM0.555664 10.6674V9.49088H8.55566V10.6674H0.555664Z"
      fill="white"
    />
  </svg>
);

const SendSVG = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.25431 7.46486L1.53887 8.03564L0.0345806 12.999C-0.0242917 13.1915 -0.00751413 13.4002 0.0812512 13.58C0.170017 13.7599 0.323909 13.8965 0.509382 13.9604C0.694999 14.0243 0.897393 14.0105 1.07312 13.9219L13.5996 7.66324C13.7605 7.58236 13.886 7.44182 13.9512 7.26982C14.0163 7.09781 14.0163 6.90676 13.9512 6.73476C13.886 6.56276 13.7605 6.42222 13.5996 6.34133L1.08171 0.0782959C0.906003 -0.0104607 0.703456 -0.0243117 0.517854 0.0395821C0.33239 0.103631 0.178649 0.240233 0.0897238 0.419949C0.000958493 0.599823 -0.0158191 0.808499 0.0430532 1.00097L1.54735 5.96435L7.25224 6.53513C7.4827 6.55874 7.65839 6.75876 7.65839 6.99763C7.65839 7.23668 7.48269 7.43668 7.25224 7.46013L7.25431 7.46486Z"
      fill="white"
    />
  </svg>
);

const CheckmarkSVG = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" r="9" className="logout-success-svg" />
    <path
      d="M16.4525 9L11.75 13.82L9.54667 11.7317L8 13.28L11.75 16.9167L18 10.5475L16.4525 9Z"
      fill="white"
    />
  </svg>
);

const ExclamationSVG = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172936 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89471 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.387 0 9 0ZM9 14.0625C8.7775 14.0625 8.55999 13.9965 8.37498 13.8729C8.18998 13.7493 8.04579 13.5736 7.96064 13.368C7.87549 13.1624 7.85321 12.9362 7.89662 12.718C7.94003 12.4998 8.04717 12.2993 8.20451 12.142C8.36184 11.9847 8.5623 11.8775 8.78053 11.8341C8.99875 11.7907 9.22496 11.813 9.43052 11.8981C9.63609 11.9833 9.81179 12.1275 9.93541 12.3125C10.059 12.4975 10.125 12.715 10.125 12.9375C10.125 13.2359 10.0065 13.522 9.7955 13.733C9.58452 13.944 9.29837 14.0625 9 14.0625ZM10.125 10.125H7.875V3.9375H10.125V10.125Z"
      className="exclamationCircle-SVG"
    />
  </svg>
);

export {
  ClaimDetailPaySVG,
  ClaimDetailDownloadSVG,
  SendSVG,
  CheckmarkSVG,
  ExclamationSVG,
};
